import React, { useEffect, useState } from "react";

// reactstrap components
import {
	Card,
	CardHeader,
	CardBody,
	Table,
	Row,
	FormGroup,
	Input,
	Label,
	Collapse,
	Col,
	Button
} from "reactstrap";
import { Link } from "react-router-dom";
import * as moment from "moment";
import { DATE_FORMATS, MESSAGES, PAGE_LIMIT } from '../../configs/constant'

import { CAMPAIGN } from '../../configs/urls'
import { getApi, deleteApi } from '../../services/api'

import Loader from '../../components/Loader'
import { useHistory } from 'react-router-dom'

import './styles.css'
import { FaEdit } from 'react-icons/fa'
import DatePicker from 'reactstrap-date-picker'

const CampaignList = () => {

	const [isRequesting, setIsRequesting] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [canShowLoadMore, setCanShowLoadMore] = useState(false)
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterParams, setFilterParams] = useState({
		page: 0,
		size: PAGE_LIMIT
	})
	const [campaigns, setCampaigns] = useState([])
	const history = useHistory()

	useEffect(() => {
		fetchCampaign(false, true)
	}, []);

	const fetchCampaign = (isLoadMore, isInitialLoad) => {
		isInitialLoad ? setIsRequesting(true) : setIsLoading(true);

		const params = JSON.parse(JSON.stringify(filterParams))

		for (const key in params) {
			if ((!params[key] && params[key] != 0) || params[key] == -1) {
				delete params[key]
			}
		}

		getApi(CAMPAIGN, params)
			.then((res) => {
				const campaignData = isLoadMore ? [...campaigns, ...res.data] : res.data;
				setCampaigns(campaignData);
				setCanShowLoadMore(campaignData.length < res.meta.total)
			}, (err) => {
				console.log(err);
			}).finally(() => {
				isInitialLoad ? setIsRequesting(false) : setIsLoading(false);
			})
	}

	const handleChange = (event) => {
		event.persist();
		setFilterParams(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const resetFilter = () => {
		setFilterParams({
			date: new Date().toISOString(),
			name: '',
			page: 0,
			size: PAGE_LIMIT
		})

		fetchCampaign();
	}


	const loadMoreCampaigns = () => {
		const params = filterParams;
		params.page++;

		setFilterParams(params)

		fetchCampaign(true);
	}

	const searchCampaigns = () => {
		const params = filterParams;
		params.page = 0;

		setFilterParams(params)

		fetchCampaign();
	}

	const viewApplications = (campaign) => {
		history.push(`/admin/application?campaign_id=${campaign.id}`)
	}

	const renderDepartments = () => (
		<div className="content">
			<Row>
				<Col md="12">
					<Card>
						<CardHeader className="header-section">
							<div>
								<Button color="primary" onClick={() => setIsFilterOpen(!isFilterOpen)}>Filter</Button>
							</div>
							<Link to="campaign/operations">
								<Button color="primary" className="text-right">Add New Campaign</Button>
							</Link>
						</CardHeader>

						<Collapse isOpen={isFilterOpen} className="border-top">
							<Card>
								<CardBody>
									<Row>
										<Col className="pr-1" md="4">
											<FormGroup>
												<label>Campaign</label>
												<Input
													type="text"
													name="name"
													placeholder="Campaign Name"
													value={filterParams.name || ""}
													onChange={handleChange}
												/>
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<FormGroup>
												<Label for="status">Date</Label>
												<DatePicker
													dateFormat={DATE_FORMATS.DATE_ONLY_FORMAT}
													value={filterParams.date}
													onChange={(value, f) => { setFilterParams({ ...filterParams, date: value }) }} />
											</FormGroup>
										</Col>

										<Col className="pr-1" md="4">
											<div className="update ml-auto mt-3 mr-auto">
												<Button className="btn-round" onClick={() => searchCampaigns()} color="primary">
													Search
												</Button>
												<Button className="btn-round ml-2" onClick={() => resetFilter()} color="primary">
													Reset
												</Button>
											</div>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Collapse>

						<hr />

						<CardBody>
							<Table>
								<thead className="text-primary">
									<tr>
										<th>ID</th>
										<th>Campaign Name</th>
										<th>Date</th>
										<th>Last Update</th>
										{/* <th className="text-right">Actions</th> */}
									</tr>
								</thead>
								<tbody>
									{
										campaigns.map((campaign, idx) => (
											<tr key={idx}>
												<td>{campaign.id}</td>
												<td onClick={() => viewApplications(campaign)} className="cursor-pointer">{campaign.name || '--'}</td>
												<td>{campaign.date ? moment(campaign.date).format(DATE_FORMATS.DATE_ONLY_FORMAT) : '--'}</td>
												<td>{campaign.updated_at ? moment(campaign.updated_at).format(DATE_FORMATS.DATE_TIME_FORMAT) : '--'}</td>
												{/* <td className="text-right action-icons">
													<Link to={`campaign/operations/${campaign.id}`}>
														<FaEdit />
													</Link>
												</td> */}
											</tr>
										))
									}
								</tbody>
							</Table>
							{
								campaigns.length == 0 &&
								<span className="no-record-found">{MESSAGES.NO_RECORD_FOUND}</span>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
			{
				canShowLoadMore &&
				<Row>
					<Col className="load-more-col">
						<Button className="action-btn" onClick={() => loadMoreCampaigns()} color="primary">Load more</Button>
					</Col>
				</Row>
			}
			<Loader isLoading={isLoading} />
		</div>
	)

	return (
		<>
			{
				isRequesting
					? <div className="content"><Loader isLoading={isRequesting} /></div>
					: renderDepartments()
			}
		</>
	);
}

export default CampaignList;
